import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GenericStepper from '../../common/widgets/genericStepper';
import GenericStep from '../../../interfaces/common/genericStep';
import UrlConstants from '../../../constants/UrlConstants';
import WorkflowUtils from '../../../utils/workflowUtils';
import LanguageUtils from '../../../utils/LanguageUtils';
import { FormType } from '../../../constants/constants';
import SellerStep1Validation from './validations/sellerStep1Validation';
import Seller from '../../../interfaces/output/seller';
import { createSeller, fetchSellerById, getSeller, isCreatingSeller, isLoadingSeller, isUpdatingSeller, updateSeller } from '../../../reducers/sellerReducer';
import SellerFormStep1 from './sellerFormStep1';
interface ISellerFormProps {
    sellerId?: number;
    steps: Array<number>;
    type: FormType;
}

const messages = {
    edit: LanguageUtils.createMessage('Edit seller'),
    add: LanguageUtils.createMessage('Add seller')
};

export default function SellerForm(props: ISellerFormProps): JSX.Element {
    const dispatch = useDispatch();
    const { sellerId, steps, type } = props;
    const [seller, setSeller] = React.useState<Seller>({ id: sellerId } as Seller);
    const [redirectCondition, setRedirectCondition] = React.useState<boolean>(false);
    const propsSeller = useSelector(getSeller);
    const propsIsUpdatingSeller = useSelector(isUpdatingSeller);
    const prevIsUpdatingSeller = WorkflowUtils.usePrevious<boolean>(propsIsUpdatingSeller);
    const propsIsCreatingSeller = useSelector(isCreatingSeller);
    const prevIsCreatingSeller = WorkflowUtils.usePrevious<boolean>(propsIsCreatingSeller);
    const propsIsLoadingSeller = useSelector(isLoadingSeller);
    const prevIsLoadingSeller = WorkflowUtils.usePrevious<boolean>(propsIsLoadingSeller);

    useEffect(() => {
        const lastStep = steps[steps.length - 1];

        switch (lastStep) {
            case 1:
                if((prevIsUpdatingSeller === true && !propsIsUpdatingSeller) || (prevIsCreatingSeller && !propsIsCreatingSeller)) {
                    setRedirectCondition(true);
                }
                break;
        }

        return () => setRedirectCondition(false);
    }, [propsIsUpdatingSeller, propsIsCreatingSeller]);

    useEffect(() => {
        if(sellerId) {
            dispatch(fetchSellerById(sellerId));
        }
    }, [dispatch]);

    useEffect(() => {
        if(prevIsLoadingSeller && !propsIsLoadingSeller) {
            setSeller(propsSeller);
        }

    }, [propsIsLoadingSeller]);

    const onChange = (attribute: string, value: any) => {
        const newSeller = { ...seller } as Seller;
        (newSeller as any)[attribute] = value;

        setSeller(newSeller);
    };

    const getSteps = (): GenericStep[] => [
        {
            id: 1,
            content: <SellerFormStep1 onChange={onChange} seller={seller} />,
            validationFn: () => SellerStep1Validation.validateSellerForm(seller),
            onNext: () => {
                if(!seller.id) {
                    dispatch(createSeller(seller));
                }
                else {
                    dispatch(updateSeller(seller));
                }
            }
        } as GenericStep
    ];

    const getTitle = (): any => {
        switch (type) {
            case FormType.Add:
                return messages.add;
            case FormType.Edit:
                return messages.edit;
            default:
                throw new Error('Form type required');
        }
    };

    const includedSteps = getSteps().filter(step => steps.includes(step.id));

    const redirectTo = (): string => {
        switch (type) {
            case FormType.Add:
                return `/${UrlConstants.SELLERS}`;

            case FormType.Edit:
                return `/${UrlConstants.SELLERS}/${seller.id}`;

            default:
                throw new Error('Redirect to required');
        }
    };

    return (
        <GenericStepper
            steps={includedSteps}
            name={getTitle()}
            redirectCondition={redirectCondition}
            redirectTo={redirectTo()}
        />
    );
}
  